import moment from 'moment'
/**
 * Translate date object into readable time string
 * @param {Object} date a date object
 * @return {String}     readable time string
 */
export default function dateToTimeString (date) {
  return moment(date).format('MM/DD/YYYY hh:mm A')
}



// WEBPACK FOOTER //
// ./modules/utils/dateToDateTimeString.js